import { ReadOnlyStepProps } from "../useStepEditor";
import { useAutomationStep } from "../../../automations/hooks/useAutomationStep";
import { Block } from "../../../../components/atoms";
import { ReadOnlyMessage } from "../../components/ReadOnlyMessage";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Icon, Stack, Title } from "@introist/react-foundation/v2";

export const SlackQuestionMessageViewer = ({ stepId }: ReadOnlyStepProps) => {
  const { step } = useAutomationStep({ id: stepId });

  if (!step || !step.resolvedData) return <div />;

  const resolvedData = step.resolvedData as any;

  const resolveAnswer = () => {
    const answer = (step.executionData as any)?.answer;
    if (!answer) return null;
    return answer.title ?? answer.value;
  };

  const answer = resolveAnswer();

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Sender & Recipients">
          <StepEditorAccordion.Row label="From">
            <Stack>
              {resolvedData.isBot ? <Icon name="robot" /> : <Icon name="person" />}
              <Title variant="bold">{resolvedData.resolvedSenderName}</Title>
            </Stack>
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="To">
            <Stack vertical>
              {(resolvedData.targetType === "users" || !resolvedData.targetType) &&
                (resolvedData.resolvedUsers as { id: string; name: string }[]).map(recipient => (
                  <Stack key={recipient.id}>
                    <Icon name="person" />
                    <Title variant="bold">{recipient.name}</Title>
                  </Stack>
                ))}
              {resolvedData.targetType === "channel" && (
                <Stack key={resolvedData.channel}>
                  <Icon name="hashtag" />
                  <Title variant="bold">{resolvedData.channel}</Title>
                </Stack>
              )}
            </Stack>
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <ReadOnlyMessage message={resolvedData.resolvedMessage!.html} />
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Collected Information">
          <StepEditorAccordion.Row label="Field">
            <Title variant="bold">{resolvedData.resolvedField.title}</Title>
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="Response">
            {!answer && <Title>No response yet</Title>}
            {answer && <Title variant="bold">{answer}</Title>}
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
